import { SET_COMMUNICATION_REDUCER } from "../types/communicationTypes";

export const setCommunicationReducer = (data) => {
  return (dispatch) => {
    dispatch({ type: SET_COMMUNICATION_REDUCER, payload: data });
  };
};
